// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var IExecutionStatus;
(function (IExecutionStatus) {
    IExecutionStatus["NOT_STARTED"] = "NOT_STARTED";
    IExecutionStatus["IN_PROCESS"] = "IN_PROCESS";
    IExecutionStatus["SUCCESS"] = "SUCCESS";
    IExecutionStatus["CANCELLED"] = "CANCELLED";
})(IExecutionStatus || (IExecutionStatus = {}));
export var ITrusteeStatus;
(function (ITrusteeStatus) {
    ITrusteeStatus["WAITING"] = "WAITING";
    ITrusteeStatus["KEY_GENERATED"] = "KEY_GENERATED";
    ITrusteeStatus["KEY_RETRIEVED"] = "KEY_RETRIEVED";
    ITrusteeStatus["KEY_CHECKED"] = "KEY_CHECKED";
})(ITrusteeStatus || (ITrusteeStatus = {}));
export var ITallyExecutionStatus;
(function (ITallyExecutionStatus) {
    ITallyExecutionStatus["NOT_STARTED"] = "NOT_STARTED";
    ITallyExecutionStatus["STARTED"] = "STARTED";
    ITallyExecutionStatus["CONNECTED"] = "CONNECTED";
    ITallyExecutionStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ITallyExecutionStatus["AWAITING_INPUT"] = "AWAITING_INPUT";
    ITallyExecutionStatus["SUCCESS"] = "SUCCESS";
    ITallyExecutionStatus["CANCELLED"] = "CANCELLED";
})(ITallyExecutionStatus || (ITallyExecutionStatus = {}));
export var ITallyTrusteeStatus;
(function (ITallyTrusteeStatus) {
    ITallyTrusteeStatus["WAITING"] = "WAITING";
    ITallyTrusteeStatus["KEY_RESTORED"] = "KEY_RESTORED";
    ITallyTrusteeStatus["KEY_CHECKED"] = "KEY_CHECKED";
})(ITallyTrusteeStatus || (ITallyTrusteeStatus = {}));
export var ITallyElectionStatus;
(function (ITallyElectionStatus) {
    ITallyElectionStatus["WAITING"] = "WAITING";
    ITallyElectionStatus["MIXING"] = "MIXING";
    ITallyElectionStatus["DECRYPTING"] = "DECRYPTING";
    ITallyElectionStatus["SUCCESS"] = "SUCCESS";
    ITallyElectionStatus["ERROR"] = "ERROR";
})(ITallyElectionStatus || (ITallyElectionStatus = {}));
export var ETallyType;
(function (ETallyType) {
    ETallyType["ELECTORAL_RESULTS"] = "ELECTORAL_RESULTS";
    ETallyType["INITIALIZATION_REPORT"] = "INITIALIZATION_REPORT";
})(ETallyType || (ETallyType = {}));
export var ETallyTypeCssClass;
(function (ETallyTypeCssClass) {
    ETallyTypeCssClass["ELECTORAL_RESULTS"] = "electoral-results";
    ETallyTypeCssClass["INITIALIZATION_REPORT"] = "init-report";
})(ETallyTypeCssClass || (ETallyTypeCssClass = {}));
export var CreateKeysError;
(function (CreateKeysError) {
    CreateKeysError["PERMISSION_LABELS"] = "permission-labels";
})(CreateKeysError || (CreateKeysError = {}));
